<template>
  <div class="modal-body">
    <div class="header proj-t-card">
      <h4>
        Envio de Boletos
        <font-awesome-icon :icon="['fas', 'barcode']" />
      </h4>
      <h6 class="sub-title">
        Envie boletos em aberto para os seus associados.
      </h6>
    </div>

    <div>
      <div v-if="dateError" class="alert alert-danger text-c-red">
        <p>O vencimento final não pode ser anterior ao vencimento inicial.</p>
      </div>
      <div class="date-container">
        <div class="col-md-6">
          <label for="start-date">Vencimento Início</label>
          <vuejs-datepicker
            v-model="date1"
            :format="datepickerFormat"
            @change="validateDates"
          />
        </div>

        <div class="col-md-6">
          <label for="end-date">Vencimento Final</label>
          <vuejs-datepicker
            v-model="date2"
            :format="datepickerFormat"
            @change="validateDates"
          />
        </div>
      </div>
    </div>

    <!-- VEICULO -->
    <div class="express-statuses">
      <label for="express-statuses">Status do Veículo:</label>
      <select
        id="express-statuses"
        v-model="selectedExpressStatuses"
        @change="expressStatusesChange"
      >
        <option disabled value="">Selecione...</option>
        <option v-for="(e, index) in expressStatuses" :key="index" :value="e">
          {{ e.name }}
        </option>
      </select>
    </div>
    <!-- REGIONAL -->
    <div class="express-statuses" v-if="expressRegional.length">
      <label for="express-regional">Regional:</label>
      <select
        id="express-regional"
        v-model="selectedExpressRegional"
        @change="expressRegionalChange"
      >
        <option disabled value="">Selecione...</option>
        <option v-for="(r, index) in expressRegional" :key="index" :value="e">
          {{ r.name }}
        </option>
      </select>
    </div>

    <!-- ASSOCIADO -->
    <div class="express-statuses" v-if="expressAssociate.length">
      <label for="express-associate">Situação do Associado:</label>
      <select
        id="express-associate"
        v-model="selectedExpressAssociate"
        @change="expressAssociateChange"
      >
        <option disabled value="">Selecione...</option>
        <option v-for="(a, index) in expressAssociate" :key="index" :value="a">
          {{ a.name }}
        </option>
      </select>
    </div>

    <!-- BOLETO -->
    <div class="express-statuses" v-if="expressBilletSituation.length">
      <label for="express-billet-situation">Situação do Boleto:</label>
      <select
        id="express-billet-situation"
        v-model="selectedExpressBilletSituation"
        @change="expressBilletSituationChange"
      >
        <option disabled value="">Selecione...</option>
        <option
          v-for="(v, index) in expressBilletSituation"
          :key="index"
          :value="v"
        >
          {{ v.name }}
        </option>
      </select>
    </div>

    <!-- MENSAGEM -->
    <div class="express-statuses" v-if="userMessage.length">
      <label for="express-user-message">Mensagem:</label>
      <select
        id="express-user-message"
        v-model="selectedUserMessage"
        @change="userMessageChange"
      >
        <option disabled value="">Selecione...</option>
        <option v-for="(u, index) in userMessage" :key="index" :value="u">
          {{ u.title }}
        </option>
      </select>
    </div>
    <Loading
      v-if="showModal"
      :isLoading="isLoading"
      :status="status"
      @close="showModal = false"
      :message="modalMessage"
    />
    <info-modal
      v-if="showConfirmModal"
      :isVisibleConfirm="showConfirmModal"
      @close="showConfirmModal = false"
      :message="modalMessage"
    />
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-dark btn-danger"
        @click="clearShippingModal"
      >
        Cancelar
      </button>
      <button
        type="button"
        class="btn btn-outline-dark btn-info"
        @click="sendData"
        :class="
          (dateError || !Object.keys(selectedUserMessage).length) && 'disabled'
        "
        :disabled="dateError || !Object.keys(selectedUserMessage).length"
      >
        Enviar
      </button>
    </div>
  </div>
</template>

<script>
import VuejsDatepicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { sendDirectExpressShippint } from '../../../../../../../api/wise';
import Loading from '../../../../components/Loading.vue';
import InfoModal from '../../../../components/InfoModal.vue';
export default {
  components: {
    VuejsDatepicker,
    Loading,
    InfoModal,
  },
  data() {
    return {
      date1: this.getCurrentDate(),
      date2: this.getCurrentDate(),
      datepickerFormat: 'DD/MM/YYYY',
      dateError: false,
      selectedExpressStatuses: {},
      selectedExpressRegional: {},
      selectedExpressAssociate: {},
      selectedExpressBilletSituation: {},
      selectedUserMessage: {},
      isLoading: false,
      status: '',
      showModal: false,
      showConfirmModal: false,
      modalMessage: '',
    };
  },
  methods: {
    clearShippingModal() {
      this.date1 = this.getCurrentDate();
      this.date2 = this.getCurrentDate();
      this.dateError = false;
      this.selectedExpressStatuses = {};
      this.selectedExpressRegional = {};
      this.selectedExpressAssociate = {};
      this.selectedExpressBilletSituation = {};
      this.selectedUserMessage = {};
      this.isLoading = false;
      this.status = '';
      this.showModal = false;
      this.modalMessage = '';
      this.closeModal();
    },
    async sendData() {
      this.showModal = true;
      this.isLoading = true;
      this.status = '';
      const payload = {
        initial_date: this.date1.toLocaleDateString('pt-BR'),
        final_date: this.date2.toLocaleDateString('pt-BR'),
        registrationCards: this.userData.registrationCards,
        status: this.selectedUserMessage.status,
        channel: this.selectedUserMessage.channel,
        situation: this.selectedUserMessage.situation,
        vehicle_situation: this.selectedExpressStatuses.name,
        billet_situation: this.selectedExpressBilletSituation.name,
        regional: this.selectedExpressRegional.name,
        user_id: this.userData._id,
        device_id: this.userData.device_id,
        client_id: this.userData.client_id,
        secret: this.userData.secret,
        integrations: this.userData.integrations,
      };

      await sendDirectExpressShippint({
        hub_url: this.userData.callbackUrl,
        payload,
      })
        .then(data => {
          this.status = 'success';
          this.isLoading = false;
          this.showModal = false;
          this.showConfirmModal = true;
          return (this.modalMessage = data.data.message);
        })
        .catch(err => {
          this.status = 'error';
          this.isLoading = false;
          this.showModal = false;
          return (this.modalMessage = err.data.error);
        })
        .finally(() => (this.isLoading = false));
    },
    getCurrentDate() {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return today;
    },
    validateDates() {
      if (this.date2 < this.date1) {
        this.dateError = true;
      } else {
        this.dateError = false;
      }
    },
    expressStatusesChange() {
      return this.selectedExpressStatuses;
    },
    expressRegionalChange() {
      return this.selectedExpressRegional;
    },
    expressAssociateChange() {
      return this.selectedExpressAssociate;
    },
    expressBilletSituationChange() {
      return this.selectedExpressBilletSituation;
    },
    userMessageChange() {
      return this.selectedExpressBilletSituation;
    },
  },
  props: {
    expressStatuses: {
      type: Array,
      require: false,
      default: () => [],
    },
    expressRegional: {
      type: Array,
      require: false,
      default: () => [],
    },
    expressAssociate: {
      type: Array,
      require: false,
      default: () => [],
    },
    expressBilletSituation: {
      type: Array,
      require: false,
      default: () => [],
    },
    userMessage: {
      type: Array,
      require: true,
      default: () => [],
    },
    userData: {
      type: Object,
      require: true,
      default: () => {},
    },
    closeModal: {},
  },
};
</script>

<style scoped>
.modal-body {
  padding: 20px;
}

.header {
  display: flex;
  flex-direction: column;
  row-gap: 5px;
  align-items: baseline;
}

.sub-title {
  margin-bottom: 0;
  font-size: 14px;
  color: #555;
}

.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}
.alert {
  padding: 10px;
  border: 2px solid red;
}
.datepicker {
  width: 100%;
  padding: 8px;
  font-size: 16px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.date-container {
  display: flex;
  gap: 20px;
  padding: 20px;
}

.express-statuses {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 5px 0;
}
.express-statuses select {
  max-width: 300px;
}
.btn {
  border-radius: 2px;
  text-transform: capitalize;
  font-size: 15px;
  padding: 0.625rem 1.1875rem;
  cursor: pointer;
  border: transparent;
}
.btn-info {
  background-color: #00bcd4;
  border-color: #00bcd4;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}
.btn-info:hover {
  background-color: #08e3ff;
  border-color: #08e3ff;
}
.btn-info:active {
  background-color: #008697;
  border-color: #008697;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}
.btn-info:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #08e3ff;
}
.btn-info.disabled {
  background-color: rgba(0, 188, 212, 0.5);
  border-color: rgba(0, 188, 212, 0.5);
}

.btn-danger {
  background-color: #ff5370;
  border-color: #ff5370;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}

.btn-danger:hover {
  background-color: #ff869a;
  border-color: #ff869a;
}

.btn-danger:active {
  background-color: #ff163d;
  border-color: #ff163d;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}

.btn-danger:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #ff869a;
}

.btn-danger.disabled {
  background-color: rgba(255, 83, 112, 0.5);
  border-color: rgba(255, 83, 112, 0.5);
}

.btn-success {
  background-color: #2ed8b6;
  border-color: #2ed8b6;
  color: #fff;
  cursor: pointer;
  -webkit-transition: all ease-in 0.3s;
  transition: all ease-in 0.3s;
}

.btn-success:hover {
  background-color: #59e0c5;
  border-color: #59e0c5;
}

.btn-success:active {
  background-color: #20a98e;
  border-color: #20a98e;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
}

.btn-success:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #fff;
  background-color: #59e0c5;
}

.btn-success.disabled {
  background-color: rgba(46, 216, 182, 0.5);
  border-color: rgba(46, 216, 182, 0.5);
}

.bg-c-red {
  background: #ff5370;
}
.text-c-red {
  color: #ff5370;
}
.bg-c-green {
  background: #2ed8b6;
}
.text-c-green {
  color: #2ed8b6;
}
.bg-c-yellow {
  background: #ffb64d;
}
.text-c-yellow {
  color: #ffb64d;
}
.m-b-5 {
  margin-bottom: 5px;
}
.m-b-0 {
  margin-bottom: 0;
}
.modal-footer {
  display: flex;
  gap: 10px;
}
</style>
